export const transactionsData = [
  {
    id: 1,
    label: "Position",
    value: {
      title: 1,
    },
  },
  {
    id: 2,
    label: "Block ID",
    value: {
      title: 57824,
    },
    underline: true,
  },
  {
    id: 3,
    label: "Age",
    value: {
      title: "114y 6m 0d 19h 40m 8s",
    },
  },
  {
    id: 4,
    label: "Inputs",
    value: {
      title: 131,
    },
  },
  {
    id: 5,
    label: "Outputs",
    value: {
      title: 1,
    },
  },
  {
    id: 6,
    label: "Input value",
    value: {
      title: "10000.00000000 BTC",
      subtitle: "$945,180,700",
    },
  },
  {
    id: 7,
    label: "Output value",
    value: {
      title: "10000.00000000 BTC",
      subtitle: "$945,180,700",
    },
  },
  {
    id: 8,
    label: "Commission",
    value: {
      title: "0.99000000 BTC",
      subtitle: "$93,572.89",
    },
    underline: true,
    comma: true,
  },
  {
    id: 9,
    label: "Commission/VB",
    value: {
      title: "-",
    },
  },
  {
    id: 10,
    label: "Size",
    value: {
      title: "23,620 Bytes",
    },
  },
  {
    id: 11,
    label: "Weight",
    value: {
      title: "94 480",
    },
  },
  {
    id: 12,
    label: "Unit of weight",
    value: {
      title: "1047.841 sat/WU",
    },
  },
  {
    id: 13,
    label: "R.B.F.",
    value: {
      title: "No",
    },
  },
  {
    id: 14,
    label: "Witness",
    value: {
      title: "No",
    },
  },
  {
    id: 15,
    label: "Version",
    value: {
      title: "1",
    },
  },
  {
    id: 16,
    label: "Blocking time",
    value: {
      title: "0",
    },
  },
  {
    id: 17,
    label: "BTC Price",
    value: {
      title: "$94,518.07",
    },
  },
];
